// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f9b54dcd","545":"1fff1ae6","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};